import localization from "../config/localization";

const getPercentString = (rawValue) => {
  let roundedValue = rawValue;
  if (typeof rawValue === "number") {
    roundedValue = Math.round(rawValue * 1000) / 10 + "%";
    roundedValue = String(roundedValue).replace(
      ".",
      localization.DECIMAL_SEPARATOR || ","
    );
  }
  return roundedValue;
};

export default getPercentString;
